var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":"fade-menu-panel"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"menu-overlay-wrapper"},[_c('div',{staticClass:"container",class:{ 'md:max-h-[calc(100vh-170px)] overflow-y-auto': _vm.hasOverflowScrollContainer }},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }